import { useMemo } from "react";
import { doLogin } from "@api/login";
import { getCurrentUserInfo } from "@api/user";
import { have_me_team } from "@api/team";
import {
  identifyDevicePlatform,
  getQueryVariable,
  getLastOrigin,
  getkey,
  currentUser,
  setCookie,
  getCookie,
  getDecodeUrl
} from "@util/utils";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import { SUPPORTED_CODES } from "@util/langConfig";
import {
  appendCurrentLanguageToUrl,
  getCurrentLanguageCode,
} from "@util/loginLanguage";

const ROUTE_CONTROL_PARAMS = ["page", "route"];

const normalizePositiveInteger = (value) => {
  const number = Number(value);
  return Number.isSafeInteger(number) && number > 0 ? number : null;
};

const buildPageUrl = (page, route) => {
  const pageUrl = `/${page}.html`;
  if (!route) return pageUrl + window.location.search;

  const routeText = String(route).replace(/^#\/?/, "").replace(/^\/+/, "");
  const queryIndex = routeText.indexOf("?");
  const routePath = queryIndex >= 0 ? routeText.slice(0, queryIndex) : routeText;
  const routeQuery = queryIndex >= 0 ? routeText.slice(queryIndex + 1) : "";
  const routeParams = new URLSearchParams(routeQuery);
  const loginParams = new URLSearchParams(window.location.search);

  loginParams.forEach((value, key) => {
    if (ROUTE_CONTROL_PARAMS.includes(key) || routeParams.has(key)) return;
    routeParams.append(key, value);
  });

  const queryText = routeParams.toString();
  return `${pageUrl}#/${routePath}${queryText ? `?${queryText}` : ""}`;
};

export default function (unicode_url) {
  const isSquare = getQueryVariable("isSquare");
  const platform_param = getkey('platform');
  const callback = getQueryVariable('callback');

  const identityType = isSquare == 1;
  const identityType_local = localStorage.getItem("identityType");
  const redirectUrl = getQueryVariable("redirectUrl");
  const { t, i18n } = useTranslation();

  const devicePlatform = identifyDevicePlatform();
  const platform = useMemo(() => {
    if (platform_param === 'MATERIAL_MALL_H5' && callback || platform_param === 'PLUG_IN') return platform_param;
    if (devicePlatform !== "phone") {
      return "MATERIAL";
    }
    return "MATERIAL_H5";
  }, [devicePlatform, platform_param]);
 
  const loginApi = (params, callback, nosetCookie = false, errorCallback) => {
    let cur_platform = platform;
    // 绑定手机号取cookie
    if (params.bindPhone) {
      cur_platform = getCookie("platform");
    }
    const h5InviterId =
      cur_platform === "MATERIAL_H5"
        ? [
            params?.inviterId,
            params?.creatorId,
            getkey("creatorId"),
            getkey("inviterId"),
          ]
            .map(normalizePositiveInteger)
            .find((value) => value !== null) ?? null
        : null;
    const obj = {
      ...params,
      ...(h5InviterId !== null ? { inviterId: h5InviterId } : {}),
      platform: cur_platform,
      regPlatform: cur_platform,
    };
    doLogin(obj).then((res) => {
      if (res.success) {
        if (!nosetCookie) {
          const days = cur_platform === "MATERIAL_H5" ? 90 : 7;
          setCookie("mtoken", res.token, days);
          setCookie("platform", cur_platform, days); 
        }
        if (callback) callback(res);
      } else {
        errorCallback?.(res)
        message.error(t(res.errorInfo));
      }
    }).catch((res)=>{
      errorCallback?.(res)
    });
  };

  // 有参数时的跳转路径
  const getUrlByHadParam = (isDetail = false,isWx=false) => {
    if (redirectUrl) {
      const targetUrl = getDecodeUrl(redirectUrl);
      return isDetail
        ? { key: "redirectUrl", val: targetUrl, url: targetUrl, type: 19 }
        : targetUrl;
    }

    // 清空询价消息标识
    setCookie('price_msg', 0, 1);
    const share_product =
      getkey("share_product") || localStorage.getItem("share_product");
    const entrust = getkey("entrust") || localStorage.getItem("entrust");
    const clientId = getkey("clientId") || localStorage.getItem("clientId");
    const unicode = getkey("unicode") || localStorage.getItem("unicode");
    const inviteCode =
      getkey("inviteCode") || localStorage.getItem("inviteCode");
    const share_main =
      getkey("share_main") || localStorage.getItem("share_main");

    const isCollect =
      getkey("isCollect")
    const product_detail_share =
      getkey("product_detail_share")
    const teamShopShare = getkey("teamShopShare")
    //收藏相关 
    const isCollectDetail =
      getkey("isCollectDetail")
    //收藏详情的id
    const collectId =
      getkey("collectId") || localStorage.getItem("collectId");
    //收藏详情的type 
    const collectType =
      getkey("collectType") || localStorage.getItem("collectType");
    const isCollectBrand =
      getkey("isCollectBrand")
    const brandId =
      getkey("brandId") || localStorage.getItem("brandId");
    //店铺分享页 
    const team_shop_share =
      getkey("team_shop_share") || localStorage.getItem("team_shop_share");
    // 邀请合作页
    const invite_collaborate = getkey("invite_collaborate") || localStorage.getItem("invite_collaborate");
    const group_certification = getkey("group_certification")

    // 紫菜海洋详情页
    const product_detail_isSquare = getkey('product_detail_isSquare')

    // 详情页未登录入库:登录后原样返回登录前的页面(路径+参数一致),URL 带标记、真实地址存 localStorage
    const collectBackUrl = getkey('collectBackUrl')

    // 是否是海外版
    const international = getkey('international')
    const page = getkey('page')
    const route = getkey('route')

    const isAddTeam =
      unicode_url && unicode_url != "null" ? unicode_url : unicode;
    //是不是从获取 优惠码的页面过来的
    const isPromotionCode = getkey("isPromotionCode")
    //是不是从 插件的页面跳转过来的
    const isSketchUpPlugins = getkey("SketchUpPlugins")
    //是不是从 插件的页面跳转过来的 铺装工具
    const isSketchUpPaving = getkey("sketchUpPaving")
    // 官网h5
    // const isReady = getkey("isReady")
    let str = "";
    let obj = {};
    if (share_product) {
      localStorage.setItem("share_product", "");
      let page = international?'/international.html#/product_detail_share':'/product_detail_share.html'
      str = `${page}?id=${share_product}&share_product=${share_product}`;
      if (teamShopShare) str += `&teamShopShare=true`;
      obj = { key: "share_product", val: share_product, url: str, type: 1 };
    }
    if (entrust) {
      localStorage.setItem("entrust", "");
      localStorage.setItem("clientId", "");
      if (clientId === entrust) {
        str = `/create_product.html?clientType=3&clientId=${entrust}&operation=CREATE&entrust=${entrust}`;
        obj = { key: "clientId", val: clientId, url: str, type: 3 };
      } else {
        str = `/entrust_product.html?key=${entrust}&entrust=${entrust}`;
        obj = { key: "entrust", val: entrust, url: str, type: 4 };
      }
    }
    if (isAddTeam) {
      localStorage.setItem("unicode", "");
      const joinClientId =
        clientId && !["null", "undefined"].includes(String(clientId))
          ? `&clientId=${encodeURIComponent(clientId)}`
          : "";
      const inviteLanguage = getCurrentLanguageCode(i18n?.language);
      const inviteLanguageParam = SUPPORTED_CODES.includes(inviteLanguage)
        ? `&fallbackLng=${encodeURIComponent(inviteLanguage)}`
        : "";
      str = `/team_join_link.html?unicode=${encodeURIComponent(isAddTeam)}${joinClientId}${inviteLanguageParam}`;
      obj = { key: "unicode", val: isAddTeam, url: str, type: 2 };
    }
    if ((identityType_local || identityType) && !entrust) {
      if (identityType_local) localStorage.setItem("identityType", "");
      str = `/material_square.html`;
      obj = { key: "identityType", val: 1, url: str, type: 7 };
    }
    if (inviteCode) {
      localStorage.setItem("inviteCode", "");
      str = `/invite_settle.html?inviteCode=${inviteCode}`;
      obj = { key: "inviteCode", val: inviteCode, url: str, type: 5 };
    }
    if (share_main) {
      localStorage.setItem("share_main", "");
      const shareLanguage = getCurrentLanguageCode(i18n?.language);
      const shareLanguageParam = devicePlatform !== "pc" && SUPPORTED_CODES.includes(shareLanguage)
        ? `&fallbackLng=${encodeURIComponent(shareLanguage)}`
        : "";
      str = `/share_page.html?key=${share_main}&isProduct=1&share_main=${share_main}${shareLanguageParam}`;

      obj = { key: "share_main", val: share_main, url: str, type: 6 };
    }
    //分享页面的时候
    if (product_detail_share) {
      let url = `/product_detail_share.html?key=${product_detail_share}`;
      if (teamShopShare) url += `&teamShopShare=true`;
      let openUrl = encodeURIComponent(url);
      str = `/loginLoading.html?isUrlOpen=1&openUrl=${openUrl}`
      obj = { key: "clientId", val: entrust, url: str, type: 11 };
    }
    if (product_detail_share && share_product) {
      localStorage.setItem("share_product", "");
      const sessionId = getkey('sessionId')
      const workId = getkey('workId')
      str = `/product_detail_share.html?id=${share_product}&share_product=${share_product}&key=${product_detail_share}&product_detail_share=${product_detail_share}`;
      if (teamShopShare) str += `&teamShopShare=true`;
      if (sessionId) {
        str += `&sessionId=${sessionId}`;
        localStorage.setItem('sessionId', '');
      }
      if (workId) {
        str += `&workId=${workId}`;
        localStorage.setItem('workId', '');
      }
      obj = { key: "share_product", val: share_product, url: str, type: 1 };
    }
    //资产页面收藏的时候跳转到
    if (isCollect) {
      let openUrl = encodeURIComponent(`/team_home.html?clientId=${entrust}&clientType=2&selectTab=3`);
      str = `/loginLoading.html?isUrlOpen=1&openUrl=${openUrl}`
      obj = { key: "isCollect", val: entrust, url: str, type: 8 };
      localStorage.setItem("entrust", entrust);
    }    //资产页面收藏的时候跳转到


    // 资产页面详细界面收藏的时候用到的
    if (isCollectDetail) {
      let openUrl = encodeURIComponent(`/product_detail.html?type=${collectType}&id=${collectId}&clientId=${entrust}&clientType=2&hadShare=0&backHome=1`);
      str = `/loginLoading.html?isUrlOpen=1&openUrl=${openUrl}`
      obj = { key: "isCollectDetail", val: entrust, url: str, type: 9 };
      localStorage.setItem("entrust", entrust);
    }
    // 品牌馆中的收藏按钮
    // 664d9e28599da769d044cbd8
    if (isCollectBrand) {
      let openUrl = encodeURIComponent(`/team.html/#/teamBrand?clientId=${entrust}&brandId=${brandId}`);
      str = `/loginLoading.html?isUrlOpen=1&openUrl=${openUrl}`
      obj = { key: "isCollectBrand", val: entrust, url: str, type: 10 };
      localStorage.setItem("entrust", entrust);
    }
    // 店铺分享页 
    if (team_shop_share) {
      localStorage.setItem("team_shop_share", "");
      str = `/team_shop_share.html?clientId=${team_shop_share}&team_shop_share=${team_shop_share}`;
      obj = { key: "team_shop_share", val: team_shop_share, url: str, type: 12 };

    }
    if (isPromotionCode) {

      let openUrl = encodeURIComponent(`/promotion_code_get.html`);
      str = `/loginLoading.html?isUrlOpen=1&openUrl=${openUrl}`
      obj = { key: "isCollectBrand", val: entrust, url: str, type: 12 };
    }

    if (invite_collaborate) {
      localStorage.setItem("invite_collaborate", "");
      str = `/invite_collaborate.html?invite_collaborate=${invite_collaborate}`;
      obj = { key: "invite_collaborate", val: invite_collaborate, url: str, type: 13 };
    }
    // 跳团队认证
    if (group_certification) {
      localStorage.setItem("group_certification", "");
      str = `/group_certification.html?clientId=${group_certification}&group_certification=${group_certification}`;
      obj = { key: "group_certification", val: group_certification, url: str, type: 14 };
    }
    if (product_detail_isSquare) {
      localStorage.setItem("product_detail_isSquare", "");
      str = `/product_detail.html?id=${product_detail_isSquare}&isSquare=1&product_detail_isSquare=${product_detail_isSquare}`;
      obj = { key: "product_detail", val: product_detail_isSquare, url: str, type: 15 };
    }
    if (isSketchUpPlugins) { 
      str = `/sketchUpPlugins.html`;
      obj = { key: "product_detail", val: product_detail_isSquare, url: str, type: 15 };
    }
    if (isSketchUpPaving) { 
      str = `/sketchUpPaving.html`;
      obj = { key: "product_detail", val: product_detail_isSquare, url: str, type: 17 };
    }

    if(page){
      str = buildPageUrl(page, route);
      if(route&&isWx){
        str='/wx_suc.html'+window.location.search;
      } else if (page === "team_join_link") {
        str = appendCurrentLanguageToUrl(str, i18n?.language);
      }
      obj = { key: page, val: page, url: str, type: 16 };
    }
    // 详情页未登录入库:原样返回登录前页面(路径+参数一致)。
    // getUrlByHadParam 在挂载与弹框提交时会多次调用,这里只读不清;
    // localStorage.collectBackUrl 的清除放在 loginLoading(跳转完成时),避免提前清空导致回跳地址丢失。
    if (collectBackUrl) {
      const storedBackUrl = localStorage.getItem('collectBackUrl') || '/';
      const backUrl = devicePlatform === "pc"
        ? storedBackUrl
        : appendCurrentLanguageToUrl(storedBackUrl, i18n?.language);
      str = `/loginLoading.html?isUrlOpen=1&openUrl=${encodeURIComponent(backUrl)}`;
      obj = { key: 'collectBackUrl', val: backUrl, url: str, type: 18 };
    }
    // const array = [];
    if (isDetail === 1) return obj;
    return str;
  };

  // 没有特殊参数=>lastUrl/团队首页/个人首页
  const noParamUrl = async (res) => {
    if (res.result?.lastUrl) {
      // 将上次记录域名换成'/'
      let lastUrl = getLastOrigin(res.result?.lastUrl);
      if (lastUrl.indexOf("token")) {
        lastUrl = lastUrl.replace("token", "test");
      }
      // const isTeam = await getHadTeam();
      const teamNumber = await findOkStateTeam()
      localStorage.setItem("lastUrl", lastUrl);
      //当没有可以直接使用的 团队且创建团队没有达到上限的话就走这里
      if (teamNumber && lastUrl.indexOf("/user_home.html") < 0) {
        window.location.href = "/team_create.html"; 
        return
      }
      // 上传最后记录是供应商入驻页
      if (lastUrl.indexOf("/supplier_settle.html") >= 0) {
        getCurrentUserInfo().then((result) => {
          const user = result || {};
          // 判断是否入驻成功
          if (
            !user?.client ||
            user?.client?.checkStatus * 1 === 2 ||
            user?.client?.checkStatus * 1 === 0
          ) {
            window.location.href = lastUrl;
          } else if (user?.client?.isForbidden) {
            window.location.href = `${window.location.origin}/supply_stop.html`;
          } else {
            window.location.href = `${window.location.origin}/supplier.html/#/product_collection`;
          }
        });
        return;
      }
      // 判断该团队是否在我的团队之中
      if (lastUrl.indexOf("/team_home.html") >= 0) {
        const clientId = getClient(lastUrl);
        if (clientId) {
          const { hadId, newTeam } = await getHadTeam(clientId);
          console.log(hadId, newTeam);
          // 不在我的团队中
          if (!hadId) {
            // 跳新创建的团队
            if (newTeam) {
              window.location.href = `/team_home.html?clientId=${newTeam.id}&clientType=2`
            } else { // 没有跳个人首页
              window.location.replace("/user_home.html");
            }
            return;
          }
        }
      }
      // 当从主页登录的时候 登录的时候没有团 就创建一个新的团队

      window.location.href = lastUrl;
    } else {
      localStorage.setItem("lastUrl", "");
      getUrlByNolasturl();
    }
  };

  //查询有没有可以使用的团队
  const findOkStateTeam = async () => {

    const { result } = await have_me_team();
    const arr = [...result.myCreated, ...result.myJoin]
    const arrLength = arr.filter(ele => {
      return !ele.isDel
    })
    return arrLength.length == 0


  }
  const getClient = (url) => {
    const arr = url.split('?');
    if (arr?.length === 2) {
      const arr_param = arr[1].split('&');
      let clientId = ''
      const find = arr_param.find(item => item.indexOf('clientId') >= 0);
      const val = find.split('=');
      if (val.length === 2) clientId = val[1];
      return clientId;
    }
    return false;
  }
  // 是否有团队
  const getHadTeam = async (id = null) => {
    try {
      const res = await have_me_team();
      const myTeamData = res?.result;
      let newTeam = null;
      let hadId = null;
      if (myTeamData?.myCreated?.length) {
        myTeamData?.myCreated.forEach((item) => {
          if (!newTeam && !item?.isDel) {
            newTeam = { ...item };
          } else if (item.tmCreate > newTeam?.tmCreate && !item?.isDel) {
            newTeam = { ...item };
          }
          if (item.id === id) hadId = id;
        });
      }
      if (myTeamData?.myJoin?.length) {
        myTeamData?.myJoin.forEach((item) => {
          if (!newTeam) {
            if (!newTeam && !item?.isDel) {
              newTeam = { ...item };
            } else if (item.tmCreate > newTeam?.tmCreate && !item?.isDel) {
              newTeam = { ...item };
            }
          }
          if (item.id === id) hadId = id;
        });
      }
      if (id) return { hadId, newTeam };
      if (newTeam) {
        return `/team_home.html?clientId=${newTeam.id}&clientType=2`;
      } else {
        return false;
      }
    } catch (error) {
      if (id) return { hadId: null, newTeam: null };
      return false;
    }
  };


  //没有上次登录记录时，
  const getUrlByNolasturl = async () => {
    if (identityType) {
      window.location.href = `/material_square.html`;
      return;
    }
    try {
      const newTeam = await getHadTeam();
      if (newTeam) {
        window.location.href = newTeam;
      } else {
        const user = currentUser();
        //不是供应商
        if (
          !user?.client ||
          user?.client?.checkStatus * 1 === 2 ||
          user?.client?.checkStatus * 1 === 0
        ) {
          //跳到个人首页
          window.location.href = `/user_home.html`;
        } else {
          //跳到供应商首页
          window.location.href = `/supplier.html/#/product_collection`;
        }
      }
    } catch (error) {
      const user = currentUser();
      //不是供应商
      if (
        !user?.client ||
        user?.client?.checkStatus * 1 === 2 ||
        user?.client?.checkStatus * 1 === 0
      ) {
        //跳到个人首页
        window.location.href = `/user_home.html`;
      } else {
        //跳到供应商首页
        window.location.href = `/supplier.html/#/product_collection`;
      }
    }
  };
  // 有团队跳到团队，没团队跳团队创建页
  const firstLogin = async () => {
    // 清空第一次登录标识
    sessionStorage.setItem("isFirst", "");
    const newTeam = await getHadTeam();
    if (newTeam) {
      window.location.href = newTeam;
    } else {
      // window.location.replace("/team_create.html");
      window.location.replace("/team_set_password.html");
    }
  };

  //输入手机或邮箱处理
  const handleSearch = (value, setOptions, type = 1) => {
    const prefixReg = /^\+86[- ]*/;
    let res = [];

    if (!value) {
      setOptions([]);
      return;
    }

    // 处理手机号前缀 +86 或 +86-
    let processedValue = value;
    if (prefixReg.test(value) && type == 1) {
      // 移除 +86 或 +86- 前缀
      processedValue = value.replace(prefixReg, '');
    }

    // 检查是否有@符号
    const atIndex = processedValue.lastIndexOf('@');

    if (atIndex !== -1) {
      // 如果有@符号，获取@之前的部分和之后的部分
      const prefix = processedValue.substring(0, atIndex + 1); // 包含@符号
      const afterAt = processedValue.substring(atIndex + 1); // @之后的内容

      // 定义支持的邮箱域名
      const emailDomains = ['163.com', 'qq.com', '126.com', 'sina.com.cn', 'sohu.com', 'outlook.com', 'icloud.com', 'gmail.com'];

      // 如果@后面有字符，进行匹配；否则显示全部
      let filteredDomains = emailDomains;
      if (afterAt) {
        filteredDomains = emailDomains.filter(domain =>
          domain.toLowerCase().startsWith(afterAt.toLowerCase())
        );
      }

      // 生成建议选项
      res = filteredDomains.map(domain => ({
        value: `${prefix}${domain}`,
        label: `${prefix}${domain}`,
      }));
    } else {
      // 如果没有@符号，不显示任何建议
      res = [];
    }

    setOptions(res);
  };

  return {
    identityType,
    loginApi,
    noParamUrl,
    getUrlByHadParam,
    getUrlByNolasturl,
    firstLogin,
    platform,
    handleSearch
  };
}
